import { render, staticRenderFns } from "./ApartmentPage.vue?vue&type=template&id=6c3196d2&scoped=true&"
import script from "./ApartmentPage.vue?vue&type=script&lang=js&"
export * from "./ApartmentPage.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentPage.vue?vue&type=style&index=0&id=6c3196d2&lang=scss&"
import style1 from "./ApartmentPage.vue?vue&type=style&index=1&id=6c3196d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3196d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3196d2')) {
      api.createRecord('6c3196d2', component.options)
    } else {
      api.reload('6c3196d2', component.options)
    }
    module.hot.accept("./ApartmentPage.vue?vue&type=template&id=6c3196d2&scoped=true&", function () {
      api.rerender('6c3196d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ApartmentPage.vue"
export default component.exports